import { isNotNil } from "es-toolkit";
import type { ContainerModule } from "inversify";
import { Container } from "inversify";
import type { DiSubmodule } from "./di-submodule";

export class DiModuleBuilder {
    get module(): Container {
        return this._module;
    }

    private get subModules(): DiSubmodule {
        return this._subModules;
    }

    get subModulesDependencies(): ContainerModule[] {
        return Object.values(this._subModules).filter(isNotNil);
    }

    private _subModules: DiSubmodule = {};

    private _module: Container = new Container();

    registerSubModules(register: () => DiSubmodule): void {
        this._subModules = register();
    }

    registerModule(): void {
        const module: Container = new Container();

        if (Object.keys(this.subModules).length === 0) {
            throw new Error(
                "No submodules have been registered. Make sure submodules exist and that registerSubmodules has been called first.",
            );
        }

        Object.values(this.subModules).forEach((subModule: ContainerModule) => {
            module.load(subModule);
        });

        this._module = module;
    }
}
